import React, { Component } from 'react'
import FilterActiveIcon from "../../icons/filteractiveicon";
import FilterIcon from "../../icons/filtericon";
import moment from 'moment-timezone'
import ReactPaginate from "react-paginate";
import TextField from '../TextField';

import DatePicker from 'react-datepicker';
import CalendarIcon from '../../icons/calendaricon';
import service from '../../services';
import Loader from '../loader';

let description
let itemsWiseFilterData = [];
let typeWiseFilterData =[];
let roleWiseFilterData = [];
let sub;

export default class TalksEvents extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            TalkandEventFilterModal: false,
            purchaseReceipt: false,
            // dateDisplayFlag: false,
            TalkandEventFlag: false,
            TalkandEvent: false,
            dateState: false,
            getAllUserActivities: [],
            purchaseList: [],
            searchField: '',
            rolesType: [
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                // { assign: "circleUser", name: "Sundance Circle", value: false },
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
                { assign: 'artistUser', name: 'Artist', value: false },
            ],
            TalkandEventType: [
                { assign: "BeyondFilm", name: "Beyond Film ", value: false },
                { assign: "Frontier", name: "New Frontier", value: false },
                { assign: 'PartnerEvent', name: 'Partner Event', value: false },
                { assign: 'PrivateEvent', name: 'Private Event', value: false },
                { assign: 'ShortProgramme', name: ' Short Programme', value: false },
            ],
            // pagination variable diclaration start
            offset: 0,
            perPage: 50,
            currentPage: 0,
            totalPages: 0,
            // pagination variable diclaration end
            activetab: 2,
            userlist: [
                { "label": "Talks & Events" },
                { "label": "Theater Details" },
                { "label": "Online Screenings" },
                { "label": "Voting" },
                { "label": "Product Sales" },
                // { "label": "Reservations" },
                { "label": "Purchases" },
            ]
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        roleWiseFilterData = [];
        itemsWiseFilterData = [];
        typeWiseFilterData=[];
    }

    componentDidMount = async () => {
        const { getLoginAdminByID, getLoginRole } = this.props
        var self = this
        this.getUserActivities(this.state.offset, this.state.perPage)
        this.setState({
            loaderFlag: true,
        });
        //  this.apiserve.sendevent("admin|getUseranalytics", { "tab": 1 });
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getUseranalytics":
                    if (!response.error) {
                        this.setState({
                            getAllUserActivities: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            // totalPages: response.data.totalPages || 0
                        }, () => {
                            this.setState({
                                loaderFlag: false,
                                TalkandEventFilterModal: false
                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
            }
        });
    }


    getUserActivities = (skip, limit) => {
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        // if (roleWiseFilterData.length) {
        //     data.role = roleWiseFilterData
        // }

        // if (typeWiseFilterData.length) {
        //     data.filmType = typeWiseFilterData
        // }

        data.page = skip
        data.limit = limit
        data.tab = 1
        this.setState({loaderFlag:true})
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }


    clearDateFilter = () => {

        this.setState({ loaderFlag: true, TalkandEventFlag: false, TalkandEvent: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (typeWiseFilterData.length) {
            data.filmType = typeWiseFilterData
        }

        data.page = 1
        data.limit = 50
        data.tab = 1
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    getAllItemFilter = (skip, limit, isClearRoleType, isClearItemType) => {
        this.setState({ loaderFlag: true })
        var data = {
            page: 1,
            limit: 50
        }

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (typeWiseFilterData.length) {
            data.filmType = typeWiseFilterData
        }

        if (this.state.TalkandEvent) {
            let fromDate = new Date(this.state.fromDate)
            let toDate = new Date(this.state.toDate)

            fromDate.setHours(0)
            fromDate.setMinutes(0)
            toDate.setHours(23)
            toDate.setMinutes(59)
            data.fromDate = fromDate
            data.toDate = toDate
        }
        data.tab = 1
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    OpenTalkandEventDateFilter = () => {
        this.setState({
            TalkandEventFilterModal: true
        })
    }
    closeTalkandEventModal = () => {
        this.setState({
            TalkandEventFilterModal: false,
        })
    }
    TalkandEventdateChangeForm = (e) => {
        this.setState({
            fromDate: e
        })
    }
    TalkandEventdateChangeTo = (e) => {
        this.setState({
            toDate: e
        })
    }
   TalkandEventclearDateFilter = () => {

        this.setState({ loaderFlag: true, TalkandEventFlag: false, TalkandEvent: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if (typeWiseFilterData.length) {
            data.filmType = typeWiseFilterData
        }
        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }

        data.page = 1
        data.limit = 50
        data.tab = 1
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    TalkandEventdateFilter = (from, to) => {
        this.setState({ loaderFlag: true, TalkandEventFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if (typeWiseFilterData.length) {
            data.filmType = typeWiseFilterData
        }
        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }
        let fromDate = new Date(from)
        let toDate = new Date(to)

        fromDate.setHours(0)
        toDate.setMinutes(0)
        toDate.setHours(23)
        toDate.setMinutes(59)

        data.page = 1
        data.limit = 50
        data.tab = 1
        data.fromDate = fromDate
        data.toDate = toDate
        this.apiserve.sendevent("admin|getUseranalytics", data);
        this.setState({ TalkandEvent: true })
    }
 //Pagination Click
 handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage + 1;
    this.setState(
        {
            currentPage: selectedPage,
            offset: offset,
            loaderFlag: true
        },
        () => {
            this.getUserActivities(this.state.offset, this.state.perPage, roleWiseFilterData);
        }
    );
};

    //role wise filter
    roleWiseFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let roleList = [...this.state.rolesType]
        roleList.forEach((key, i) => {
            if (i === index) {
                roleList[i].value = event
            }
            if (isClearRoleType) {
                roleList[i].value = false
                roleWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            rolesType: roleList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                    roleWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType);
        })
    };
//role wise filter
TypeWiseFilter = (e, selectedInex, isClearRoleType = false, isClearFilmType) => {
    let index = selectedInex
    let event = e && e.target && e.target.checked
    let TypeList = [...this.state.TalkandEventType]
    TypeList.forEach((key, i) => {
        if (i === index) {
            TypeList[i].value = event
        }
        if (isClearFilmType) {
            TypeList[i].value = false
            typeWiseFilterData = []
        }

    })
    this.setState({
        ...this.state,
        TalkandEventType: TypeList,
        currentPage: 0
    }, () => {
        if (event) {
            if (index !== null) {
                typeWiseFilterData = [...typeWiseFilterData, this.state.TalkandEventType[index].assign];
            }
        } else {
            if (index !== null) {
                let tempArray = typeWiseFilterData.filter((d) => d !== this.state.TalkandEventType[index].assign);
                typeWiseFilterData = tempArray;
            }
        }
        this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearFilmType);
    })
};


    render() {
        const { itemsWiseFilterData, getAllUserActivities, sprofileName } = this.state
        const { closeModal,closeTalkandEventModal,typeWiseFilterData,rolesType,roleWiseFilter,OpenTalkandEventDateFilter,TalkandEventclearDateFilter,TalkandEventFlag,TalkandEventFilterModal,itemsTypeFilter,TalkandEventdateChangeForm,TalkandEventdateChangeTo,TalkandEventdateFilter,dateStringLabelTalkandEvent,fromDate,toDate,TalkandEventfromDate,TalkandEventtoDate,TalkandEventType,roleWiseFilterData } = this.props
        // let dateStringLabelTalkandEvent = `${moment(this.state.fromDate).tz("US/Mountain").format('MM/DD/YYYY')} - ${moment(this.state.toDate).tz("US/Mountain").format('MM/DD/YYYY')}`;
        return (
            <>
                <div className="dashboard_data">
                    <table>
                        <thead>
                            <th style={{ width: "222px" }} className="pl_25"><span>Email</span></th>
                            <th style={{ width: "110px" }}><span>First Name</span></th>
                            <th style={{ width: "110px" }}><span>Last Name</span></th>
                            <th style={{ width: "120px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Role
                                    {roleWiseFilterData && roleWiseFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }

                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">

                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => roleWiseFilter(null, null, true, null)}>Clear All</p>
                                                </div>
                                                {rolesType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => roleWiseFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "130px" }}>
                                <span className="d_flex d_flex_align_center">
                                Title
                                    {/* {itemsWiseFilterData && itemsWiseFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    } */}
                                </span>
                            </th>
                            <th style={{ width: "140px" }}>
                                <span>Type
                                {typeWiseFilterData && typeWiseFilterData.length ?
                                                                        <FilterActiveIcon />
                                                                        :
                                                                        <FilterIcon />
                                                                    }

                                </span>
                                      <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => this.props.TypeWiseFilter(null, null, null, true)}>Clear All</p>
                                                </div>
                                                {TalkandEventType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => this.props.TypeWiseFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "140px" }}>
                                <span>Location</span>
                            </th>
                            {/* <th style={{ width: "90px" }}>
                            <span>Order ID</span>
                        </th> */}
                            {/* <th style={{ width: "140px" }}>
                            <span>Order Amount</span>
                        </th> */}
                            {/* <th style={{ width: "80px" }}>
                            <span>Items</span>
                        </th> */}
                            {/* <th style={{ width: "110px" }}>
                            <span>Coupon</span>
                        </th> */}
                            {/* <th style={{ width: "110px" }}>
                                <span>Zip Code</span>
                            </th> */}
                            {/* <th style={{ width: "110px" }}>
                            <span>Payment Method</span>
                        </th>
                         */}
                            <th style={{ width: TalkandEventFlag ? "230px" : "190px" }} className="text_center">
                                {TalkandEventFlag ?
                                    <>
                                        <span className="pointer date_filter_btn" >
                                            {dateStringLabelTalkandEvent}
                                        </span>
                                    
                                        <p onClick={TalkandEventclearDateFilter} className="text_right mt_5 blue pointer">Clear</p>
                                    </>
                                    :
                                    <span className="pointer date_filter_btn" onClick={OpenTalkandEventDateFilter}>Event Date/Time</span>
                                }
                            </th>
                            <th style={{ width: "110px" }}>
                            <span>Scanned</span>
                        </th>
                        </thead>
                        <tbody>
                            {getAllUserActivities.map((getUserActivity, i) => {
                                return (
                                    <tr>
                                        <td style={{ width: "222px" }} className="pl_25">{getUserActivity && getUserActivity.userData && getUserActivity.userData.email}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userData && getUserActivity.userData.fname}</td>
                                        <td style={{ width: "110px" }}>{getUserActivity && getUserActivity.userData && getUserActivity.userData.lname}</td>
                                        <td style={{ width: "120px" }}>{getUserActivity && getUserActivity.userData && getUserActivity.userData.role === 'sioUser' ? 'Industry User' :
                                            getUserActivity && getUserActivity.userData && getUserActivity.userData.role === 'pressUser' ? 'Press User' :
                                                getUserActivity && getUserActivity.userData && getUserActivity.userData.role === 'circleGuestUser' ? 'Sundance Guest' :
                                                    getUserActivity && getUserActivity.userData && getUserActivity.userData.role === 'generalUser' ? 'General User' :
                                                        getUserActivity && getUserActivity.userData && getUserActivity.userData.role === 'artistUser' ? 'Artist User' : '-'}</td>
                                        <td className="d_flex d_flex_align_center Item_cart" style={{ width: "130px", minHeight: "57px", height: "auto" }}>
                                            {getUserActivity && getUserActivity.filmDetail && getUserActivity.filmType == "ShortProgramme"?getUserActivity.filmDetail.name: getUserActivity.filmDetail.title}
                                        </td>
                                        {/* <td>{getUserActivity &&  getUserActivity.filmType}</td> */}
                                        <td style={{ width: "120px" }}>{getUserActivity && getUserActivity.filmType && getUserActivity.filmType === 'BeyondFilm' ? 'Beyond Film' :
                                            getUserActivity && getUserActivity.filmType && getUserActivity.filmType === 'Frontier' ? 'New Frontier' :
                                                getUserActivity && getUserActivity.filmType && getUserActivity.filmType === 'PartnerEvent' ? 'Partner Event' :
                                                    getUserActivity && getUserActivity.filmType && getUserActivity.filmType === 'ShortProgramme' ? 'Short Programme' :
                                                        getUserActivity && getUserActivity.filmType && getUserActivity.filmType === 'PrivateEvent' ? 'Private Event' : '-'}</td>
                                        <td> {getUserActivity && getUserActivity.filmDetail.dateTime.locations.length == 0?"-": getUserActivity.filmDetail.dateTime.locations[0].name} </td>
                                    <td style={{ width: "140px" }}>{moment(getUserActivity.filmDetail.dateTime.date).tz("US/Mountain").format('MM/DD/YYYY  h:mm A')}</td>
                                    <td style={{ width: "140px" }}> {getUserActivity && getUserActivity.isScanned === true ? moment(getUserActivity.scannedDate).tz("US/Mountain").format('MM/DD/YYYY h:mm A')  : "Not Scanned"}</td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
                {/* Pagination View Display */}
                {getAllUserActivities.length && getAllUserActivities ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.props.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.props.currentPage}
                        />
                    </div>
                ) : (
                    ""
                )}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                    ""
                )}

                {
                    TalkandEventFilterModal ?
                        <div className='user_popup active'>
                            <span className="popup_overlay" onClick={closeTalkandEventModal}></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial" >
                                <div className="approve_popup_header text_center relative pb_0">
                                    <span className="close_popup" onClick={closeTalkandEventModal}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                        </svg>
                                    </span>
                                    <h3 className="mb_10">Select Date Filter { }</h3>
                                </div>
                                <div className="content">
                                    <div className="date_content d_flex d_flex_justify_center">

                                        <div className="from_date d_flex d_flex_align_center d_flex_justify_center">
                                            <TextField type="text" name="countDownDate" label="From" disabled={true} value={moment(fromDate).format(
                                                "MM/DD/YYYY"
                                            )}
                                                placeholder="mm / dd / yyyy" />

                                            <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                <DatePicker
                                                    selected={fromDate}
                                                    onChange={(e) => TalkandEventdateChangeForm(e)}
                                                    placeholderText="mm / dd / yyyy"
                                                    maxDate={new Date()}

                                                    customInput={
                                                        <span className="calendar">
                                                            <CalendarIcon opacity="1" />
                                                        </span>
                                                    }

                                                />
                                            </div>
                                        </div>
                                        <div className="to_date d_flex d_flex_justify_center">
                                            <TextField type="text" name="countDownDate" label="To" disabled={true} value={moment(toDate).format(
                                                "MM/DD/YYYY"

                                            )} placeholder="mm / dd / yyyy" />


                                            <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                <DatePicker
                                                    selected={toDate}
                                                    onChange={(e) => TalkandEventdateChangeTo(e)}
                                                    maxDate={new Date()}
                                                    placeholderText="mm / dd / yyyy"
                                                    customInput={
                                                        <span className="calendar">
                                                            <CalendarIcon opacity="1" />
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row text_center">
                                        <button className="active" onClick={(e) => TalkandEventdateFilter(fromDate, toDate)}>Submit </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ""
                }
            </>
        )
    }
}

